module.exports = __webpack_public_path__ + "static/img/qingmei.50b1bea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/qingmei.png
// module id = /6Jo
// module chunks = 1